import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class ExcelInventoryImport_ds_get_locations_by_namesService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { names: string[], warehouses?: string[] }): 
  Promise<{ result: { Id?: number, IsLoose?: boolean, Name?: string, Warehouse?: { Id?: number, Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.names)) {
      missingRequiredInParams.push('\'names\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/ExcelInventoryImport/datasources/ds_get_locations_by_names/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { names: string[], warehouses?: string[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, IsLoose?: boolean, Name?: string, Warehouse?: { Id?: number, Name?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.names)) {
      missingRequiredInParams.push('\'names\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/ExcelInventoryImport/datasources/ds_get_locations_by_names/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { names: string[], warehouses?: string[], $keys: number[] }): 
  Promise<{ result: { Id?: number, IsLoose?: boolean, Name?: string, Warehouse?: { Id?: number, Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.names)) {
      missingRequiredInParams.push('\'names\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/ExcelInventoryImport/datasources/ds_get_locations_by_names/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      names: string[], warehouses?: string[]    }) {
        if(isNil(inParams.names)) {
          return true; 
        }
      return false;
    }
}
